import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

function PhotoDropzone({ onFilesSelected, maxFiles = 5 }) {
  const { t } = useTranslation();
  const [dragActive, setDragActive] = useState(false);
  const [filePreviews, setFilePreviews] = useState([]);
  const inputRef = useRef();

  // Handle files from input or drop
  const handleFiles = files => {
    const fileArray = Array.from(files).slice(0, maxFiles);
    setFilePreviews(fileArray.map(file => ({
      file,
      url: URL.createObjectURL(file)
    })));
    if (onFilesSelected) onFilesSelected(fileArray);
  };

  // Handle drop event
  const handleDrop = e => {
    e.preventDefault();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFiles(e.dataTransfer.files);
    }
  };

  // Handle file picker
  const handleChange = e => {
    if (e.target.files && e.target.files.length > 0) {
      handleFiles(e.target.files);
    }
  };

  return (
    <div
      onDragOver={e => { e.preventDefault(); setDragActive(true); }}
      onDragLeave={e => { e.preventDefault(); setDragActive(false); }}
      onDrop={handleDrop}
      style={{
        border: dragActive ? '2px solid #1976d2' : '1px dashed #adb5bd8c',
        borderRadius: 8,
        padding: 24,
        textAlign: 'center',
        background: dragActive ? '#f0f8ff' : '#fafafa',
        cursor: 'pointer',
        transition: 'border 0.2s'
      }}
      onClick={() => inputRef.current.click()}
    >
      <input
        type="file"
        accept="image/*"
        multiple
        ref={inputRef}
        style={{ display: 'none' }}
        onChange={handleChange}
        max={maxFiles}
      />
      <div>
        <strong>{t('PageAdmin.CompanyDeviceRecordTable.DragAndDroPhotosHere')}</strong>
        <br />
        <span>{t('PageAdmin.CompanyDeviceRecordTable.UploadPhotos1')}{maxFiles}{t('PageAdmin.CompanyDeviceRecordTable.UploadPhotos2')}</span>
      </div>
      <div style={{ marginTop: 16, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {filePreviews.map(({ url, file }, idx) => (
          <img
            key={idx}
            src={url}
            alt={file.name}
            style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 4, border: '1px solid #ccc' }}
          />
        ))}
      </div>
    </div>
  );
}

export default PhotoDropzone;
